export default function () {
    return {
        "airway_blocked": "ae4d9244-be4c-4d2f-8700-258d2225d0d3",
        "airway_threatened": "514f0a81-457e-4276-b917-598e7bb3094b",
        "airway_unblocked": "ce493686-b5e2-489b-b443-bfa6c4a20791",
        "respiratory_rate": "c8658f88-65e5-4808-bf02-53ee9cf09d4e",
        "spo2_with_o2": "0d52f77f-6ee3-4333-9127-1d00fa5f1fd7",
        "spo2_without_o2": "c6641932-0a68-4e19-a41f-d5cfce60c5e9",
        "regular_rhythm": "12a81b10-e2b1-451c-b02d-d7a60ea0aba1",
        "irregular_rhythm": "bfd8d4de-c1a2-4190-8b06-f0110b0b029f",
        "heart_rate": "ef872c64-8dd4-40e9-bdb7-46de858c0fa5",
        "sbp": "54934e7b-785f-4be0-a04f-8ad0925ddc96",
        "alert": "0983b667-6e9f-4cc0-9594-fbbb3ed07ff0",
        "sudden_confusion": "6aa784a9-1721-4d69-8ab9-be857625bd81",
        "somnolent": "4e775bc9-9d73-4e4e-b51e-b5c0dde61ccc",
        "seizures": "037ffe72-4d6c-49ef-812f-8af5fc7d0af4",
        "rls": "dca97698-2d74-49ee-aa9f-2a7f8ed75d38",
        "gcs": "76015b5e-b020-4d18-9f10-1e295b35e41c",
        "temp": "ed6fc9a3-6c2f-486b-83f6-cdf409ebb708"
    };
};


// WEBPACK FOOTER //
// ./retts/Assessment/vpNameAndId.js